import { Box, Icon } from '@jfs/ui-new'
import { FC } from 'react'
import { Platform } from 'react-native'
import { SvgImage } from '../../../comps/SvgImage'
import { useIsMobile } from '../../../util/useFontSize'
import { testProps } from '../../../util/util'

interface ShowHidePasswordProps {
  hide?: boolean
  isDisabled?: boolean
  isPasswordVisible: (data: boolean) => void
  showPassword: boolean
}

const ShowHidePassword: FC<ShowHidePasswordProps> = ({
  hide,
  isDisabled,
  isPasswordVisible,
  showPassword,
}: ShowHidePasswordProps) => {
  const isMob = useIsMobile()
  if (hide) {
    return null
  }
  const onPress = () => {
    isPasswordVisible(!showPassword)
  }
  return (
    <Box disabled={isDisabled} {...testProps('toggle-pwd')} onPress={onPress} underlayColor={'TRANSPARENT'}>
      {isMob || ['ios', 'android'].includes(Platform.OS) ? (
        <SvgImage imageName={showPassword ? 'eyeVisibleOn' : 'eyeVisibleOff'} width={24} height={24} />
      ) : (
        <Icon id={showPassword ? 'EYE_WATCH' : 'EYE_WATCH_SELECTED'} color="PRIMARY" size="FONT_SIZE_LARGE" />
      )}
    </Box>
  )
}
export default ShowHidePassword
